var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "850.39px",
    height: "850.39px",
    viewBox: "0 0 850.39 850.39",
    enableBackground: "new 0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.407,348.901c0,20.398-16.534,36.935-36.938,36.935c-20.398,0-36.937-16.537-36.937-36.935 c0-20.401,16.539-36.938,36.937-36.938C451.873,311.963,468.407,328.5,468.407,348.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.407,551.786c0,13.464-14.827,24.387-33.128,24.387h-11.96c-18.297,0-33.131-10.923-33.131-24.387V416.31 c0-13.47,14.834-24.388,33.131-24.388h11.96c18.301,0,33.128,10.918,33.128,24.388V551.786z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.862,
    y: 507.951,
    width: 12.182,
    height: 243.787
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "473.246,751.73 473.246,639.513 361.028,639.513  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "361.044,639.51 361.036,751.728 473.254,751.736  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "leftHand",
    d: "M357.614,503.39c8.159,0.001,14.774-6.614,14.773-14.772v-66.053c0-8.161-6.615-14.775-14.774-14.775l0,0 c-8.158,0-14.776,6.614-14.776,14.775l0,66.053C342.837,496.775,349.455,503.39,357.614,503.39L357.614,503.39z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 531.746,
    y: 563.524,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 594.2206 -295.3554)",
    width: 243.786,
    height: 12.183
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "656.18,739.449 576.83,660.099 656.18,580.749  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "656.167,580.758 735.522,660.103 656.179,739.458  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "rightHand",
    d: "M492.842,412.118c-5.769,5.769-5.769,15.124,0,20.894l46.704,46.705c5.774,5.771,15.13,5.772,20.898,0.004 l0,0c5.772-5.772,5.771-15.127-0.003-20.9l-46.703-46.704C507.969,406.347,498.614,406.345,492.842,412.118L492.842,412.118z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.fe033c24728156c95a0e51ce6b562c23.svg";
export { ForwardRef as ReactComponent };